import React, { useEffect, useState } from "react";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogContent, Grid } from "@mui/material";
import { DateTimeStandard, Typography, Box } from "@curves/ui-base";
import useMemberTokenApi from "@apis/useMemberTokenApi";
import useEmployeeTokenApi from "@apis/useEmployeeTokenApi";
import { ReadTextField } from "@icoach/components";
import { parseDate } from "@util/moment";
import { MEMBER_SITE_LOGON_TYPE } from "@constants/";
import { MEMBER_SITE_LOGON_TYPE_DESCRIPTION } from "@constants/appConfig"

const MemberSiteQrCodeDialog = React.forwardRef((
    {
        logonType = MEMBER_SITE_LOGON_TYPE.MEMBER,
        open = false,
        onClose,
        sourceData,
        hideCaptcha = false,
    }, ref) => {
    if (!open) return null;
    const { referenceID = 0 } = sourceData || {};
    const { getMemberQrcodeApi } = useMemberTokenApi();
    const { getEmployeeQrcodeApi } = useEmployeeTokenApi();
    const [data, setData] = useState({});

    const {
        hasMemberSite = true,
        qrcode,
        expiredDate,
        captcha,
    } = data;

    const doGetQrcodeApi = async refID => {
        let resp = logonType === MEMBER_SITE_LOGON_TYPE.MEMBER
            ? await getMemberQrcodeApi(refID)
            : await getEmployeeQrcodeApi(refID);
        if (resp) setData(resp);
    };

    useEffect(
        () => {
            if (open) {
                doGetQrcodeApi(referenceID);
            }
        },
        // eslint-disable-next-line
        [open]
    );

    const target = MEMBER_SITE_LOGON_TYPE_DESCRIPTION[logonType];
    const title = `Curves ${target}平台`;

    return (
        <Dialog
            className={"qr-code-dialog"}
            open={open}
            PaperProps={{ className: 'wx-65rem' }}
            fullWidth
        >
            <GradientColorHeader onClose={onClose}>{hasMemberSite ? `請掃描綁定${target}` : `無法綁定${target}`}</GradientColorHeader>
            <DialogContent>
                {hasMemberSite ? (
                    <Box className={"text-center"}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant={'h2'} color={'main'}>{title}</Typography>
                                {qrcode && <img style={{ width: "420px", height: "420px" }} src={qrcode} alt={"qrcode"} />}
                            </Grid>
                            {captcha && !hideCaptcha
                                ? (
                                    <>
                                        <Grid item xs={12}>
                                            <ReadTextField className={"captcha"} label={"驗證碼"}>
                                                {captcha}
                                            </ReadTextField>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant={"body2"}>請掃描上方QR Code，並輸入驗證碼，綁定 {title}。</Typography>
                                            {expiredDate &&
                                                <Typography className={"font-color-3"}
                                                            variant={"body2"}>{`預計於${parseDate(expiredDate, DateTimeStandard.DisplayFullBySlash)}失效`}</Typography>
                                            }
                                        </Grid>
                                    </>

                                ) : (

                                    <Grid item xs={12}>
                                        <Typography variant={"body2"}>掃描QRCode，綁定 {title}。</Typography>
                                        {expiredDate &&
                                            <Typography className={"font-color-3"}
                                                        variant={"body2"}>{`預計於${parseDate(expiredDate, DateTimeStandard.DisplayFullBySlash)}失效`}</Typography>
                                        }
                                    </Grid>

                                )
                            }
                        </Grid>
                    </Box>
                ) : (
                    <Box>
                        <Grid item xs={12}>
                            <Typography variant={"h3"} align={"center"}>店舖暫不支援綁定功能</Typography>
                        </Grid>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
        ;
});

export default MemberSiteQrCodeDialog;
